import { GetterTree } from 'vuex/types';
import { InstallationState } from '.';
import { MechanicInstallation, InstallationModule } from '@/types';

export default {
  ['module'](state, getters, rootState, rootGetters) {
    return (id: number, moduleType: string) => {
      const installation: MechanicInstallation = rootGetters['installations/details'](id);

      const serverModule = installation?.modules.find(mod => mod.type === moduleType);

      if (!serverModule) {
        return undefined;
      }

      const localModule = state.installations[id]?.modules[moduleType];

      return { ...serverModule, data: { ...serverModule.data, ...localModule?.data } };
    };
  },

  ['updatedAt'](state, getters) {
    return (id: number, moduleType: string) => {
      return (getters['module'](id, moduleType) as InstallationModule)?.updatedAt;
    };
  },

  ['hasChanges'](state, getters, rootState, rootGetters) {
    return (id: number, moduleType: string) => {
      return !!state.installations[id].modules[moduleType];
    };
  },

  ['installation'](state, getters, rootState, rootGetters) {
    return (id: number): MechanicInstallation | undefined => {
      const installation: MechanicInstallation = rootGetters['installations/details'](id);

      return installation
        ? {
            ...installation,
            modules: installation.modules?.map(mod => getters['module'](id, mod.type)),
          }
        : undefined;
    };
  },

  ['item'](state) {
    return (id: number) => {
      return state.installations[id];
    };
  },

  ['status'](state) {
    return (id: number, type: string) =>
      (state.installations[id] && state.installations[id].status[type]) || { status: false };
  },
} as GetterTree<InstallationState, any>;
